import { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { getPropiedadesAdmin, eliminarPropiedad, editarPropiedad } from "../../firebase/propiedades";

const BADGE = {
  Disponible: { background: "#dcfce7", color: "#16a34a" },
  Vendida: { background: "#fee2e2", color: "#dc2626" },
  Alquilada: { background: "#fef9c3", color: "#ca8a04" },
  "No disponible": { background: "#f3f4f6", color: "#374151" },
};

const TIPOS = ["Casa", "Terreno", "Hectárea/Campo", "Departamento", "Local/Oficina"];
const ESTADOS = ["Disponible", "Vendida", "Alquilada", "No disponible"];

export default function Propiedades() {
  const navigate = useNavigate();
  const [propiedades, setPropiedades] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState("");
  const [busqueda, setBusqueda] = useState("");

  async function cargar() {
    setCargando(true);
    const data = await getPropiedadesAdmin();
    setPropiedades(data);
    setCargando(false);
  }

  useEffect(() => { cargar(); }, []);

  async function handleEliminar(id) {
    if (!window.confirm("¿Seguro que querés eliminar esta propiedad?")) return;
    await eliminarPropiedad(id);
    cargar();
  }

  async function handleEstado(id, nuevoEstado) {
    await editarPropiedad(id, { estado: nuevoEstado });
    cargar();
  }

  const filtradas = useMemo(() =>
    [...propiedades]
      .filter(p => {
        if (filtroTipo) {
          const tipos = p.tipos || (p.tipo ? [p.tipo] : []);
          if (!tipos.includes(filtroTipo)) return false;
        }
        if (busqueda.trim()) {
          const q = busqueda.toLowerCase();
          const codigo = p.numeroProp ? `p1${p.numeroProp}` : "";
          return (
            (p.titulo || "").toLowerCase().includes(q) ||
            (p.ubicacion || "").toLowerCase().includes(q) ||
            (p.barrio || "").toLowerCase().includes(q) ||
            (p.cliente || "").toLowerCase().includes(q) ||
            codigo.includes(q)
          );
        }
        return true;
      })
      .sort((a, b) => {
        const precioA = a.precio || a.precioInterno || 0;
        const precioB = b.precio || b.precioInterno || 0;
        return precioA - precioB;
      }),
    [propiedades, filtroTipo, busqueda]
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f4f4f4", fontFamily: "system-ui, sans-serif" }}>

      <div style={{ background: "#fff", borderBottom: "1px solid #e5e5e5", padding: "20px 32px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div>
          <button onClick={() => navigate("/admin")} style={{ background: "none", border: "none", color: "#9ca3af", fontSize: "12px", cursor: "pointer", marginBottom: "4px", display: "block", fontFamily: "system-ui" }}>
            ← Volver al dashboard
          </button>
          <h1 style={{ fontSize: "22px", fontWeight: "700", color: "#111827" }}>Propiedades</h1>
          <p style={{ fontSize: "13px", color: "#9ca3af", marginTop: "2px" }}>{propiedades.length} propiedades cargadas</p>
        </div>
        <button
          onClick={() => navigate("/admin/propiedades/nueva")}
          style={{ background: "#1a9e2a", color: "#fff", border: "none", borderRadius: "10px", padding: "12px 20px", fontWeight: "700", fontSize: "14px", cursor: "pointer" }}
        >
          + Nueva propiedad
        </button>
      </div>

      <div style={{ height: "4px", background: "#1a9e2a" }} />

      <div style={{ maxWidth: "900px", margin: "0 auto", padding: "28px 20px" }}>

        {/* BARRA DE BÚSQUEDA */}
        <input
          type="text"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar por título, ubicación, barrio o código (ej: P101)..."
          style={{
            width: "100%",
            padding: "11px 16px",
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
            fontSize: "14px",
            outline: "none",
            background: "#fff",
            boxSizing: "border-box",
            marginBottom: "14px",
            fontFamily: "system-ui",
          }}
        />

        {/* FILTROS */}
        <div style={{ display: "flex", gap: "8px", marginBottom: "20px", flexWrap: "wrap", alignItems: "center" }}>
          <button
            onClick={() => setFiltroTipo("")}
            style={{ padding: "8px 20px", borderRadius: "20px", border: "1px solid #1a9e2a", background: filtroTipo === "" ? "#1a9e2a" : "#fff", color: filtroTipo === "" ? "#fff" : "#1a9e2a", fontWeight: "600", fontSize: "13px", cursor: "pointer" }}
          >
            Todos
          </button>
          {TIPOS.map((tipo) => (
            <button
              key={tipo}
              onClick={() => setFiltroTipo(filtroTipo === tipo ? "" : tipo)}
              style={{ padding: "8px 20px", borderRadius: "20px", border: "1px solid #1a9e2a", background: filtroTipo === tipo ? "#1a9e2a" : "#fff", color: filtroTipo === tipo ? "#fff" : "#1a9e2a", fontWeight: "600", fontSize: "13px", cursor: "pointer" }}
            >
              {tipo}
            </button>
          ))}
          {!cargando && (
            <span style={{ fontSize: "13px", color: "#6b7280", marginLeft: "auto" }}>
              {filtradas.length} {filtradas.length === 1 ? "resultado" : "resultados"}
            </span>
          )}
        </div>

        {cargando ? (
          <p style={{ color: "#9ca3af", fontSize: "14px" }}>Cargando propiedades...</p>
        ) : filtradas.length === 0 ? (
          <p style={{ color: "#9ca3af", fontSize: "14px" }}>
            {propiedades.length === 0 ? "No hay propiedades cargadas todavía." : "No hay resultados para esa búsqueda."}
          </p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {filtradas.map((p) => {
              const imagenes = p.imagenes || (p.imagen ? [p.imagen] : []);
              const badge = BADGE[p.estado] || { background: "#f3f4f6", color: "#6b7280" };
              const tipos = p.tipos || (p.tipo ? [p.tipo] : []);
              return (
                <div key={p.id} style={{ background: "#fff", borderRadius: "16px", padding: "16px 20px", display: "flex", gap: "16px", alignItems: "center", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>

                  <img
                    src={imagenes[0] || "https://via.placeholder.com/60x60?text=?"}
                    alt={p.titulo}
                    style={{ width: "64px", height: "64px", objectFit: "cover", borderRadius: "10px", flexShrink: 0 }}
                  />

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap", marginBottom: "2px" }}>
                      <h2 style={{ fontSize: "15px", fontWeight: "700", color: "#111827", margin: 0 }}>
                        {p.numeroProp && (
                          <span style={{ fontSize: "11px", fontWeight: "700", color: "#1a3c5e", background: "#dbeafe", padding: "2px 8px", borderRadius: "6px", marginRight: "8px" }}>
                            P1{p.numeroProp}
                          </span>
                        )}
                        {p.titulo}
                      </h2>
                      <span style={{ fontSize: "11px", padding: "2px 10px", borderRadius: "20px", fontWeight: "600", background: badge.background, color: badge.color }}>
                        {p.estado || "Sin estado"}
                      </span>
                    </div>
                    <p style={{ fontSize: "12px", color: "#9ca3af", margin: "2px 0" }}>
                      📍 {p.ubicacion}
                      {p.visitas > 0 && (
                        <span style={{ marginLeft: "10px", fontSize: "11px", color: "#9ca3af" }}>
                          👁 {p.visitas} {p.visitas === 1 ? "visita" : "visitas"}
                        </span>
                      )}
                    </p>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center", marginTop: "6px", flexWrap: "wrap" }}>
                      {p.precio > 0 && (
                        <span style={{ fontSize: "15px", fontWeight: "700", color: "#1a9e2a" }}>
                          ${p.precio.toLocaleString()}
                        </span>
                      )}
                      {p.precioInterno > 0 && (
                        <span style={{ fontSize: "13px", fontWeight: "700", color: "#a16207", background: "#fef9c3", border: "1px solid #fde047", padding: "2px 10px", borderRadius: "8px", display: "inline-flex", alignItems: "center", gap: "4px" }}>
                          🔒 ${p.precioInterno.toLocaleString()}
                        </span>
                      )}
                      <span style={{ fontSize: "11px", color: "#9ca3af" }}>{p.operacion}</span>
                      {tipos.map((t) => (
                        <span key={t} style={{ fontSize: "11px", background: "#f3f4f6", color: "#374151", padding: "2px 8px", borderRadius: "20px", fontWeight: "600" }}>
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div style={{ display: "flex", flexDirection: "column", gap: "8px", flexShrink: 0, alignItems: "flex-end" }}>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        onClick={() => navigate(`/admin/propiedades/editar/${p.id}`)}
                        style={{ background: "#eff6ff", color: "#2563eb", border: "none", borderRadius: "8px", padding: "6px 14px", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}
                      >
                        ✏️ Editar
                      </button>
                      <button
                        onClick={() => handleEliminar(p.id)}
                        style={{ background: "#fef2f2", color: "#dc2626", border: "none", borderRadius: "8px", padding: "6px 14px", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}
                      >
                        🗑️ Eliminar
                      </button>
                    </div>
                    <select
                      value={p.estado || "Disponible"}
                      onChange={(e) => handleEstado(p.id, e.target.value)}
                      style={{ fontSize: "12px", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "5px 8px", outline: "none", color: "#374151", background: "#fff", cursor: "pointer" }}
                    >
                      {ESTADOS.map((e) => <option key={e}>{e}</option>)}
                    </select>
                  </div>

                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
